export function readStorage(storage: Storage | undefined, key: string): string {
  try {
    return storage?.getItem(key) || '';
  } catch {
    return '';
  }
}

export function writeStorage(storage: Storage | undefined, key: string, value: string) {
  try {
    storage?.setItem(key, value);
  } catch {
    // Storage may be unavailable in private browsing.
  }
}

export function removeStorage(storage: Storage | undefined, key: string) {
  try {
    storage?.removeItem(key);
  } catch {
    // Storage may be unavailable in private browsing.
  }
}
